import Avatar, { type AvatarProps } from './Avatar';
import Body, { type BodyProps } from './Body';
import Comment, { type CommentProps } from './Comment';
import CommentInput, { type CommentInputProps } from './CommentInput';
import CommentList, { type CommentListProps } from './CommentList';
import Comments, { type CommentsProps } from './Comments';
import Content, { type ContentProps } from './Content';
import Footer, { type FooterProps } from './Footer';
import Header, { type HeaderProps } from './Header';
import Root, { type RootProps } from './Root';
import Timestamp, { type TimestampProps } from './Timestamp';
import Title, { type TitleProps } from './Title';

export type {
  RootProps,
  HeaderProps,
  AvatarProps,
  TimestampProps,
  ContentProps,
  TitleProps,
  BodyProps,
  FooterProps,
  CommentsProps,
  CommentInputProps,
  CommentListProps,
  CommentProps,
};

export const ActivityFeedItem = {
  Root,
  Header,
  Avatar,
  Timestamp,
  Content,
  Title,
  Body,
  Footer,
  Comments,
  CommentInput,
  CommentList,
  Comment,
};
